/**
 * Vidéos du catalogue (lecture, création, mise à jour, suppression).
 *
 * Extrait de l'ancien services/api.ts (Lot 8, déplacement pur).
 */

import {
  Video,
} from '../types';
import type { ApiResponse, DataResponse } from '../types/api';
import { ADMIN_URLS } from '../config/adminApi';
import { createApiClient, withEnv } from '../lib/http';
import { AppEnvironment } from '../config/environment';

const api = createApiClient();

export class VideosApiService {
  /** Liste les vidéos de l'environnement. */
  static async getVideos(env: AppEnvironment): Promise<Video[]> {
    const response = await api.get<DataResponse<Video[]>>(`/videos`, withEnv(env));
    return response.data.data;
  }

  /** Lit une vidéo par son identifiant. */
  static async getVideoById(env: AppEnvironment, id: string): Promise<Video> {
    const response = await api.get<DataResponse<Video>>(`/videos/${id}`, withEnv(env));
    return response.data.data;
  }

  /** Crée une vidéo. */
  static async createVideo(env: AppEnvironment, video: Omit<Video, 'id'>): Promise<ApiResponse<Video>> {
    const response = await api.post<ApiResponse<Video>>(`/videos`, video, withEnv(env));
    return response.data;
  }

  /** Met à jour une vidéo. */
  static async updateVideo(env: AppEnvironment, id: string, video: Partial<Video>): Promise<ApiResponse<Video>> {
    const response = await api.put<ApiResponse<Video>>(`/videos/${id}`, video, withEnv(env));
    return response.data;
  }

  /** Supprime une vidéo. */
  static async deleteVideo(env: AppEnvironment, id: string): Promise<ApiResponse<void>> {
    const response = await api.delete<ApiResponse<void>>(`${ADMIN_URLS.content}/videos/${id}`, withEnv(env));
    return response.data;
  }
}

export default VideosApiService;
